import _ from 'underscore';

app.GuestSurveyOptionsView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} guest-survey-options-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {};
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();

        return fields.label || '';
      },
      templateData: {
        title: 'Guest Survey Options',
        buttonText: 'new guest survey option',
        emptyText: 'No guest survey options yet.',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
